import React from "react";
import PropTypes from 'prop-types';
import moment from "moment";
import {FormattedMessage} from "react-intl";

import Header from "./monthHeaderView";
import Day from "./dayView";
import Misc from "../../../misc/misc";

export default class MonthView extends React.Component {
    static propTypes = {
        dateChanged: PropTypes.func,
        selectedDate: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            m: this.props.selectedDate,
            today: moment(),
            selectedDate: this.props.selectedDate
        };
    }

    handlePrevMonthClick = (e) => {
        Misc.ignoreDefault(e);
        this.setState({m: this.state.m.subtract(1, 'months')});
    };

    handleNextMonthClick = (e) => {
        Misc.ignoreDefault(e);
        this.setState({m: this.state.m.add(1, 'months')});
    };

    handleDayClick = (date) => {
        const selectedDate = moment(this.state.m).date(date);
        this.setState({selectedDate: selectedDate});
        this.props.dateChanged(selectedDate);
    };

    handleTodayClick = (e) => {
        Misc.ignoreDefault(e);
        this.setState({
            m: moment(),
            selectedDate: moment()
        });
        this.props.dateChanged(moment());
    };

    render() {
        return (
            <div className="confirmation-calendar-wrapper">
                <Header m={this.state.m}/>
                {this.renderDays()}
                {this.renderButtons()}
                <div className="confirmation-set-today-wrapper" onClick={this.handleTodayClick}>
                    <div className="confirmation-set-today-icon">
                        <div className="confirmation-set-today-day">{this.state.selectedDate.format('ddd')}</div>
                        <div className="confirmation-set-today-number">{this.state.selectedDate.date()}</div>
                    </div>
                    <h1><FormattedMessage id="confirmationScheduleView.setCalendar"/></h1>
                </div>
            </div>
        );
    }

    renderDays = () => {
        const res = [];
        let i;
        let cnt = 0;

        const mom = moment(this.state.m);
        mom.date(1);
        const dayOfWeek = mom.day();
        for (i = 0; i < dayOfWeek; i++) {
            res.push(<Day number="" key={'prefix' + i}/>);
            cnt++;
        }

        const daysInMonth = this.state.m.daysInMonth();
        const selected = this.state.selectedDate || this.state.today;
        for (i = 0; i < daysInMonth; i++) {

            res.push(<Day number={i + 1} key={'day' + i}
                          selected={selected.month() === this.state.m.month() &&
                          (i + 1) === selected.date() &&
                          selected.year() === this.state.m.year()}
                          click={this.handleDayClick}/>);
            cnt++;
        }

        const moreCnt = 7 - (cnt % 7);
        for (i = 0; moreCnt !== 7 && i < moreCnt; i++) {
            res.push(<Day number="" key={'postfix' + i}/>);
            cnt++;
        }

        return res;
    };

    renderButtons = () => {
        return (
            <div className="confirmation-calendar-button-container">
                <div className="confirmation-calendar-back-button" onClick={this.handlePrevMonthClick}>
                    <div className="confirmation-calendar-back-button-endcap"/>
                    {moment(this.state.m).subtract(1, 'months').format('MMMM')}
                </div>
                <div className="confirmation-calendar-forward-button" onClick={this.handleNextMonthClick}>
                    <div className="confirmation-calendar-forward-button-endcap"/>
                    {moment(this.state.m).add(1, 'months').format('MMMM')}
                </div>
            </div>
        );
    }
}
